import axiosInstance from "./axiosInstance";

const ContractService = {
    getContracts: (page = 0, size = 10, search = '', statuses = []) => {
        const params = new URLSearchParams({ page, size });
        if (search) params.append('search', search);
        statuses.forEach(s => params.append('statuses', s));
        return axiosInstance.get(`/api/contracts?${params}`).then(r => r.data);
    },

    getStats: () =>
        axiosInstance.get('/api/contracts/stats').then(r => r.data),

    getContract: (id) =>
        axiosInstance.get(`/api/contracts/${id}`).then(r => r.data),

    updateContract: (id, data) =>
        axiosInstance.put(`/api/contracts/${id}`, data).then(r => r.data),

    deleteContract: (id) =>
        axiosInstance.delete(`/api/contracts/${id}`),

    generateFromQuote: (quoteId, data) =>
        axiosInstance.post(`/api/quotes/${quoteId}/generate-contract`, data).then(r => r.data),

    draftBrief: (quoteId, language) =>
        axiosInstance.post(`/api/quotes/${quoteId}/draft-contract-brief`, { language }).then(r => r.data),

    regenerate: (id, data) =>
        axiosInstance.post(`/api/contracts/${id}/regenerate`, data).then(r => r.data),

    startSigning: (id) =>
        axiosInstance.post(`/api/contracts/${id}/start-signing`).then(r => r.data),

    cancelSigning: (id) =>
        axiosInstance.post(`/api/contracts/${id}/cancel-signing`),

    requestChanges: (id, comment) =>
        axiosInstance.post(`/api/contracts/${id}/request-changes`, { comment }).then(r => r.data),

    createProject: (id) =>
        axiosInstance.post(`/api/contracts/${id}/create-project`).then(r => r.data),

    getRevisions: (id) =>
        axiosInstance.get(`/api/contracts/${id}/revisions`).then(r => r.data),

    downloadContract: (id) =>
        axiosInstance.get(`/api/contracts/${id}/download`, { responseType: 'blob' }),

    getNotes: (id) =>
        axiosInstance.get(`/api/contracts/${id}/notes`).then(r => r.data),

    addNote: (id, content, visibility) =>
        axiosInstance.post(`/api/contracts/${id}/notes`, { content, visibility }).then(r => r.data),

    updateNote: (id, noteId, content) =>
        axiosInstance.put(`/api/contracts/${id}/notes/${noteId}`, { content }).then(r => r.data),

    deleteNote: (id, noteId) =>
        axiosInstance.delete(`/api/contracts/${id}/notes/${noteId}`),
};

export default ContractService;
